import { render, staticRenderFns } from "./OtherDevs.vue?vue&type=template&id=6b21b63e&scoped=true&"
import script from "./OtherDevs.vue?vue&type=script&lang=js&"
export * from "./OtherDevs.vue?vue&type=script&lang=js&"
import style0 from "./OtherDevs.vue?vue&type=style&index=0&id=6b21b63e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b21b63e",
  null
  
)

export default component.exports